module.exports = __webpack_public_path__ + "static/media/gib.a3d08694.svg";